<div class="row h-100">
  <div class="col-md-6 super-compos-left-shadow">
    <i-title [text]="'homeCourrier.docToSign' | translate"></i-title>
    <i-table
      [paginator]="true"
      class="super-table"
      [columns]="columns"
      [items]="files"
      (onClickRow)="openFile($event)"
      id="documenttovalidates"
      [forselectionDefaultOption]="false"
      [search]="true"
      [forselection]="forselection"
      [multiselect]="true"
      [paginator]="true"
      [height]="'calc(100vh - 120px)'"></i-table>
  </div>
  @if (!fileToShow) {
    <div class="col-md-6 viewerFull d-flex align-items-center justify-content-center">
      <img src="./assets/img/decoration/nofiles.svg" width="600" class="img-fluid" alt="" />
    </div>
  }
  @if (fileToShow) {
    <div class="col-md-6 viewerFull mt-4">
      <div class="d-flex align-items-center justify-content-center mb-4">
        <i-button styleClass="blue me-2" text="Voir la fiche courrier liée #{{ fileToShow.mailId }}" (click)="goTo(fileToShow.mailId)"></i-button>
      </div>
      <app-courrier-file-viewer [currentFiles]="fileToShow" class="d-block font-source"></app-courrier-file-viewer>
    </div>
  }
</div>
<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="refuseModal"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'homeCourrier.refuseSign' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3" [formGroup]="formRefuse">
    <div class="col-md-12 mb-2">
      <label class="super-compos-label-input">{{ 'dashboard.comment' | translate }}</label>
      <textarea
        rows="5"
        cols="30"
        [placeholder]="'docToValidate.insertComment' | translate"
        formControlName="justification"
        class="super-compos-input-text form-control w-100"
        pInputTextarea></textarea>
    </div>
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="refuseModal = false" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" (click)="validateRefusal()" [text]="'confirm' | translate"></i-button>
</p-dialog>
